import React from 'react';
import styled from 'styled-components';
import { connect, getIn } from 'formik';

export const StyledError = styled.div`
  color: #f93e3f;
  font-size: 14px;
  font-family: Mukta, sans-serif;
  padding: 5px 0;
`;

interface Props {
  name: string;
  isHidden?: boolean;
  formik?: any;
}

const ErrorMessage: React.ComponentType<Props> = connect(
  ({ name, isHidden, formik: { errors, touched } }) => {
    const error = getIn(errors, name);
    const touch = getIn(touched, name);

    if (isHidden) {
      return touch && error ? <StyledError>{error}</StyledError> : null;
    }

    return <StyledError>{touch && error ? error : '\u00A0'}</StyledError>;
  },
);

export default ErrorMessage;
